import { request } from "../http";

export default {
    // 补全资料
    fillInfo(params) {
        return request('post', '/sd_smi/api/v1/Web_User/fillInfo', params, 'json');
    },

    // 获取个人信息
    getUserInfo(params) {
        return request('post', '/sd_smi/api/v1/Web_User/getUserinfo', params, 'json');
    },

    // 平台绑定
    bindPlatform(params) {
        return request('post', '/sd_smi/api/v1/Web_User/bindPlatform', params, 'json');
    },

    // 平台解绑
    unbindPlatform(params) {
        return request('post', '/sd_smi/api/v1/Web_User/unbindPlatform', params, 'json');
    },

    // 获取我的案例
    getMyCaseList(params) {
        return request('post', '/sd_smi/api/v1/H5_Case/getCaseList', params, 'json');
    },
}



// WEBPACK FOOTER //
// ./src/request/apis/user.js